module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba_funabashi_point3_2-2458580403dd81efa56495734964f748.jpg";